<div>
    <div class="loader-scene pt-1">
        <i [className]="loaderIcon+' loader'"></i>
    </div>
    <div class="text-center fa-fade" style="--fa-animation-duration: 3s;">
        {{'shared.loading' | transloco}}
    </div>
</div>